/* Copyright Information: Created by BuyGroup */
import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import "../Quotes/Quotes.css";

const AssignSupplierModal = ({
  isOpen,
  toggle,
  suppliers,
  onSubmit,
  isSubmitting,
}) => {
  const [selectedSuppliers, setSelectedSuppliers] = useState([]);

  // Handle checkbox change
  const handleSupplierCheckboxChange = (supplierId) => {
    setSelectedSuppliers((prev) => {
      if (prev.includes(supplierId)) {
        return prev.filter((id) => id !== supplierId);
      } else {
        return [...prev, supplierId];
      }
    });
  };

  // Handle submit
  const handleSubmit = () => {
    if (selectedSuppliers.length === 0) {
      return;
    }
    onSubmit(selectedSuppliers);
  };

  // Reset selections when modal closes
  const handleClose = () => {
    setSelectedSuppliers([]);
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={handleClose} size="lg">
      <ModalHeader toggle={handleClose}>Assign Supplier</ModalHeader>
      <ModalBody>
        {suppliers && suppliers.length > 0 ? (
          <div className="supplier-list-container">
            {suppliers.map((supplier) => (
              <div
                key={supplier.id || supplier.supplier_id}
                className="supplier-item-wrapper"
              >
                <FormGroup check className="supplier-item">
                  <Label check>
                    <Input
                      type="checkbox"
                      checked={selectedSuppliers.includes(supplier.id)}
                      onChange={() =>
                        handleSupplierCheckboxChange(supplier.id)
                      }
                    />
                    <div className="supplier-info">
                      <div className="supplier-name">
                        {supplier.company_name}
                      </div>
                      {supplier.email && (
                        <div className="supplier-email">{supplier.email}</div>
                      )}
                    </div>
                  </Label>
                </FormGroup>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-muted">No suppliers available</div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={handleSubmit}
          disabled={isSubmitting || selectedSuppliers.length === 0}
        >
          {isSubmitting ? "Please Wait..." : "Submit"}
        </Button>
        <Button color="light" onClick={handleClose} disabled={isSubmitting}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AssignSupplierModal;
/* Copyright Information: Created by BuyGroup */

